import React from 'react';
import { useSelector } from 'react-redux';
import GlobalSelectors from '../../../../../store/global-selectors';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerStatus, BannerLayout } from 'ui-components/components/banner-message/banner-enums';
import { useFundLimitRemaining } from '../../../../../hooks/account-information/use-fund-limit-remaining';
import { MINIMUM_PURCHASE_AMT } from '../constants/add-funds-constants';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import { useModal } from '../../../../../hooks/use-modal';
import { VerifiedMerchantRequestModal } from '../../../../../components/modals/verified-merchant-request-modal/index';
import { messages } from './messages';
import style from './styles.module.less';

export const FundLimitBanner = () => {
  const { limit } = useSelector(GlobalSelectors.selectAccountInformationAccountInformation) || {};
  const limitRemaining = useFundLimitRemaining();
  const isAtLimit = limitRemaining < MINIMUM_PURCHASE_AMT;
  const status = isAtLimit ? BannerStatus.Error : BannerStatus.Info;
  const { close, isOpen, open } = useModal();

  return (
    <>
      <BannerMessageV2
        content={
          <Text
            formattedMessageValues={{
              button: (chunks) => (
                <Button className={style['spending-limit-button']} onClick={open} theme='tertiary'>
                  {chunks}
                </Button>
              ),
              limit,
              limitRemaining,
            }}
            textType={TextType.Paragraph}
            value={messages.limitMessage}
          />
        }
        header={
          <Text
            formattedMessageValues={{
              limit,
            }}
            textType={TextType.Paragraph}
            value={isAtLimit ? messages.limitReachedHeader : messages.limitPresentHeader}
          />
        }
        layout={BannerLayout.Full}
        status={status}
      />
      {isOpen && <VerifiedMerchantRequestModal onClose={close} />}
    </>
  );
};
